import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import ModalShell from '../common/modal-shell';
import BasicSpinner from '../common/basic-spinner';
import PaginatedList from '../common/pagination';

import { useAuth } from "../../utils/auth-provider";
import { fetchUserItems } from '../../utils/fetch-helpers'

import ItemCreateForm from '../item/item-create-form';

//================================================================

export default function ItemsPage(){

  const user = useAuth();

  const [items, setItems] = useState();
  const [modalShow, setModalShow] = useState(false);

  //----------------------------------------------------------------

  const fetchItems = async (signal) => {
    setItems( await fetchUserItems(user, signal));
  };

  //----------------------------------------------------------------

  const addItem = useCallback(async (item) => {
    setItems([...items, item]);
    setModalShow(false);
  }, [items]);

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchItems(signal);

    return () => {
      // Cancel the request when the component unmounts
      abortController.abort();
    };
  }, []);

  //----------------------------------------------------------------

  return(
    <>
      {!items ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-3 align-items-center">
            <Col className="h4 my-0 text-start">Items:</Col>
            <Col className="text-end">
              <Button
                className="text-nowrap"
                onClick={() => setModalShow(true)}
              >
                Add New Item
              </Button>
            </Col>
          </Row>

          <PaginatedList
            key='user-items'
            list={items}
            type='item'
            isPrivate={true}
          />
        </>
      }

      <ModalShell
        title="Add New Item"
        show={modalShow}
        onHide={() => setModalShow(false)}
        hideFooter={true}
      >
        <ItemCreateForm
          onCancel={() => setModalShow(false)}
          onCreate={addItem}
        />
      </ModalShell>
    </>
  );
}
